module.exports = __webpack_public_path__ + "img/807-a07ed2.png";